<template>
  <div class="container-header">
    <!-- header导航 -->
    <div class="header">
      <div class="left">
        <div class="logo">
          <img v-lazy="require('@/assets/fp1.png')" alt="丰派收银" />
        </div>
        <div class="nav">
          <div
            :class="
              routerName == '/webindex'
                ? 'nav-item nav-item-active'
                : 'nav-item'
            "
            @click.stop="routerMenu('/webindex')"
          >
            首页
          </div>
          <!-- <div
            :class="
              routerName == '/web/webproduct'
                ? 'nav-item nav-item-product nav-item-active'
                : 'nav-item nav-item-product'
            "
            @mouseenter="productMenuList = true"
            @mouseleave="productMenuList = false"
          >
            产品
            <div v-show="productMenuList" class="productContainer-arrow"></div>
            <div v-show="productMenuList" class="productContainer">
              <div
                @click.stop="routerMenu('/web/webproduct')"
                :class="
                  routerName == '/web/webproduct'
                    ? 'productContainer-item active'
                    : 'productContainer-item'
                "
              >
                收银系统
              </div>
              <div @click.stop="goGb" class="productContainer-item">
                智慧零售
              </div>
              <div @click.stop="goDb" class="productContainer-item">
                订货平台
              </div>
            </div>
          </div> -->
          <div
            :class="
              routerName == '/web/webdownload'
                ? 'nav-item nav-item-active'
                : 'nav-item'
            "
            @click.stop="routerMenu('/web/webdownload')"
          >
            下载
          </div>
          <!-- <div
            :class="
              routerName == '/web/webintroduce'
                ? 'nav-item nav-item-active'
                : 'nav-item'
            "
            @click.stop="routerMenu('/web/webintroduce')"
          >
            公司简介
          </div> -->
          <!-- 暂时隐藏结构已写好 -->
          <!-- <div
            :class="
              routerName == '/web/webhelp'
                ? 'nav-item nav-item-active'
                : 'nav-item'
            "
            @click.stop="routerMenu('/web/webhelp')"
          >
            客户支持
          </div> -->
        </div>
      </div>
      <div class="right">
        <div class="right-item" @click.stop="gotoLogin">商户登录</div>
        <div class="right-item" @click="gotoRegister">免费试用</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "iheader",
  data() {
    return {
      routerName: "",
      productMenuList: false, //产品下拉
    };
  },
  watch: {
    $route: {
      handler(val) {
        this.routerName = val.path;
      },
    },
  },
  mounted() {
    this.routerName = this.$route.path;
  },
  methods: {
    gotoLogin() {
      location.href = "https://www.vx8848.com/vxPos/#/login";
    },
    gotoRegister() {
      location.href = "https://www.vx8848.com/vxPos/#/register";
    },
    goGb() {
      window.open("https://www.lg8848.cn");
    },
    goDb() {
      window.open("https://www.ld8848.cn");
    },
    routerMenu(result) {
      if (!result) {
        this.$message.warning("暂无网址");
        return;
      }
      this.$router.push({ path: result });
      //   this.routerName = result;
    },
  },
};
</script>
<style lang="less" scoped>
.container-header {
  width: 100%;
  min-width: 950px;
  display: flex;
  justify-content: center;
  box-shadow: 4px 4px 12px rgba(55, 99, 170, 0.08);
  backdrop-filter: blur(8px);
  position: fixed;
  background: rgba(255, 255, 255, 0.9);
  z-index: 8;
  left: 0;
  top: 0;
}
.header {
  width: 1200px;
  min-width: 950px;
  padding: 0 20px 0 40px;
  height: 64px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .left {
    height: 64px;
    // line-height:80px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .logo {
      // width: 120px;
      height: 46px;
      overflow: hidden;
      display: flex;
      align-items: center;
      margin-right: 40px;
      img {
        // width: 120px;
        height: 46px;
      }
    }
    .nav {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: 100px;
      .nav-item {
        cursor: pointer;
        box-sizing: border-box;
        height: 64px;
        line-height: 64px;
        color: #333333;
        font-size: 16px;
        margin-right: 60px;
        &:hover {
          color: #3d60dd;
        }
      }
      .nav-item-product {
        position: relative;
      }
      .productContainer-arrow {
        position: absolute;
        top: 54px;
        left: 30px;
        width: 0;
        height: 0;
        filter: drop-shadow(0px 2px 12px rgba(0, 0, 0, 0.5));
        border-left: 6px solid transparent;
        border-right: 6px solid transparent;
        border-bottom: 6px solid #fff;
        z-index: 200;
      }
      .productContainer {
        position: absolute;
        top: 60px;
        left: -20px;
        width: 116px;
        height: 114px;
        z-index: 100;
        filter: drop-shadow(0px 2px 12px rgba(0, 0, 0, 0.1));
        padding-bottom: 6px;
        .productContainer-item {
          width: 100%;
          height: 34px;
          line-height: 34px;
          background: #ffffff;
          font-weight: 350;
          font-size: 14px;
          color: #606266;
          text-align: center;
        }
        .productContainer-item:hover {
          background: #c9d9f1;
        }
        .active {
          color: #3d60dd;
          background: #f5f7fa;
        }
      }
      .nav-item:last-child {
        margin-right: 0;
      }
      .nav-item-active {
        font-weight: bold;
        color: #3d60dd;
        font-size: 16px;
      }
    }
  }
  .right {
    width: 238px;
    height: 64px;
    flex: 1;
    display: flex;
    justify-content: flex-end;
    .right-item {
      cursor: pointer;
      box-sizing: border-box;
      height: 64px;
      line-height: 64px;
      color: #333333;
      font-size: 16px;
      margin-right: 36px;
      &:hover {
        color: #3d60dd;
      }
    }
    .dls {
      cursor: pointer;
      width: 112px;
      height: 64px;
      background: #336fff;
      color: #fff;
      text-align: center;
      line-height: 64px;
    }
    .right-item:last-child {
      margin-right: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pc/header.vue